<template>
    <AuthLayout>
        <div
            class="flex w-full flex-col items-center bg-white px-6 pb-6 sm:max-w-[344px]"
        >
            <div class="flex justify-center">
                <img
                    :src="dmarceyee"
                    class="h-[160px] w-[160px] object-contain"
                    alt="Dmarceyee wishes you farewell image"
                />
            </div>

            <div
                class="mt-6 text-center text-3xl font-bold leading-9 text-[#161E2E]"
            >
                {{ $t("vue.all_done_logged_out") }}
            </div>

            <div
                class="mt-6 max-w-[344px] text-center text-[12.25px] font-normal leading-[1.42] text-black"
            >
                {{ $t("vue.sorry_to_see_you_go") }}
            </div>

            <div class="mt-6 w-full">
                <inertia-link :href="route('login')" class="block w-full">
                    <MegaButton
                        class="w-full !rounded-md !bg-[#088BEA] !py-3 !text-sm !font-medium !text-white !shadow-none hover:!bg-[#067DD2] focus:!ring-0"
                    >
                        {{ $t("vue.sign_in_again") }}
                    </MegaButton>
                </inertia-link>
            </div>
        </div>
    </AuthLayout>
</template>

<script lang="ts" setup>
import route from "ziggy-js";

const selectedImage = Math.floor(Math.random() * 2);

const dmarceyee = new URL(
    "/resources/js/assets/images/dmarceye-robot.svg",
    import.meta.url,
).href;
</script>
